import * as yup from "yup";

export const  editBusinessValidationSchema = yup.object().shape({
  business: yup.string().required("Business name is required"),
  business_headline: yup
    .string()
    .required("Business headline is required")
    .min(45, "Headline must be at least 45 characters")
    .max(80, "Headline must be at most 80 characters"),

  business_description: yup.string().required("Description is required"),
  address1: yup.string(),
  // address2: yup
  //   .string()
  //   .url("Invalid URL format"),
    

  // city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipcode: yup.string().required("Zip code is required"),
  phone: yup.string().required("Phone number is required").required(),
});
